import { useResponsive } from '@/hooks';
import { ResponsiveCollection } from '@/interfaces';
import { PMTAdType, adUnitsInsideParcelList } from '@/modules/pmt/constants';
import { CustomAdsense, CustomSquareAdsense } from '../Shipments/Shipments.styles';

const ADS_INSIDE_PARCEL_LIST_LENGTH = Object.entries(adUnitsInsideParcelList).length;

interface ShipmentAdsProps {
  idx: number;
}

export const ShipmentAds: React.FC<ShipmentAdsProps> = ({ idx }) => {
  const { isDesktopPMT } = useResponsive([ResponsiveCollection.DesktopPMT]);
  const adIndex = idx / 3;

  if (!adUnitsInsideParcelList[adIndex]) return null;

  return (
    <>
      {/* [Desktop only - setup A] Show horizontal ads after first shipment card */}
      {isDesktopPMT && idx === 0 && adIndex < ADS_INSIDE_PARCEL_LIST_LENGTH && (
        <CustomAdsense
          className='pmt-inside-parcel-list'
          key={`pmt-inside-parcel-list-${adIndex}`}
          id={`pmt-inside-parcel-list-${adIndex}`}
          variant={adUnitsInsideParcelList[adIndex]}
        />
      )}
      {/* [Desktop + Mobile] Show horizontal ads after every 3 shipment cards */}
      {idx !== 0 && idx % 3 === 0 && adIndex < ADS_INSIDE_PARCEL_LIST_LENGTH && (
        <CustomAdsense
          className='pmt-inside-parcel-list'
          key={`pmt-inside-parcel-list-${adIndex}`}
          id={`pmt-inside-parcel-list-${adIndex}`}
          variant={adUnitsInsideParcelList[adIndex]}
        />
      )}
      {/* [Mobile only] Show a square ad after first ad unit right after first shipment card */}
      {!isDesktopPMT && idx === 0 && (
        <CustomSquareAdsense
          className='pmt-square-inside-parcel-list'
          key={`mobile-pmt-square-inside-parcel-list-${idx}`}
          id={`pmt-square-inside-parcel-list-${idx}`}
          variant={PMTAdType.PMT_SQUARE_AD_PARCEL_LIST}
        />
      )}
    </>
  );
};
